import { shellStringResources } from '../../Resources/ShellStringResources';
import { IModel, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { TriggerProperties } from './trigger-properties';
import moment from 'moment';

@Metamodel.model({
    name: 'RerunTumblingWindowTrigger',
    display: [shellStringResources.ModelName_RerunTumblingWindowTrigger, shellStringResources.ModelName_RerunTumblingWindowTriggers]
})
export class RerunTumblingWindowTriggerProperties extends TriggerProperties {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ParentTrigger,
        constraint: {
            required: true
        }
    })
    public parentTrigger: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_RequestedStartTime,
        constraint: {
            required: true
        }
    })
    public requestedStartTime: Date;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_RequestedEndTime,
        constraint: {
            required: true,
            validator: RerunTumblingWindowTriggerProperties.validateEndTime
        }
    })
    public requestedEndTime: Date;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_RerunConcurrency,
        constraint: {
            required: true,
            maximum: 50,
            minimum: 1,
            whole: true
        }
    })
    public rerunConcurrency: number;

    public constructor() {
        super();
        this.multiplePipelines = undefined;
    }

    private static validateEndTime(triggerProperties: RerunTumblingWindowTriggerProperties, requestedEndTime?: Date): IViolation[] | undefined {
        if (requestedEndTime && moment(requestedEndTime).diff(triggerProperties.requestedStartTime) < 0) {
            return [
                {
                    message: () => shellStringResources.Trigger_EndTimeAfterStart
                }
            ];
        }
        return undefined;
    }
}
